var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableFuncionarios',{attrs:{"headers":_vm.headers,"funcionarios":_vm.items,"cargando":_vm.cargando}})}
var staticRenderFns = []

export { render, staticRenderFns }